<template>
  <div class="teamDetail">
    <!-- <el-button class="add_btn" size="medium" type="primary" icon="el-icon-plus" @click="addMember">添加队员</el-button> -->
    <el-page-header @back="$router.go(-1)" :content="$route.query.name">
    </el-page-header>

    <el-table
      class="team_list"
      :data="memberList"
      border
      style="margin-top: 30px"
    >
      <el-table-column
        prop="avatar"
        label="队员头像"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-image
            style="width: 44px; height: 44px"
            :src="
              scope.row.avatar || require('@/assets/images/icons/icon_me.png')
            "
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column
        prop="nickName"
        label="队员姓名"
        width="180"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="post" label="岗位名称" width="180" align="center">
      </el-table-column>
      <el-table-column
        prop="status"
        label="审核状态"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 'RESOLVE'" style="color: #6ce115"
            >已通过</span
          >
          <span v-if="scope.row.status == 'PENDING'" style="color: #ffc55f"
            >审核中</span
          >
          <span v-if="scope.row.status == 'REJECT'" style="color: #f56c6c"
            >已拒绝</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="加入日期"
        :formatter="formatter"
        width="200"
        align="center"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-show="!scope.row.isCaptain"
            @click.native.prevent="
              handleCaptain(scope.row.teamUserId, scope.row.nickName)
            "
            type="text"
            size="small"
          >
            提升为队长
          </el-button>
          <el-button
            @click.native.prevent="
              deleteRow(scope.row.teamUserId, scope.row.nickName)
            "
            type="text"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { memberList, delTeamMember, upCaptain } from "@/api/team";
import { formatDate } from "@/utils/index";

export default {
  name: "teamDetail",
  data() {
    return {
      memberList: [],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //   成员列表
    getList() {
      this.$loading.show();
      memberList({ teamId: this.$route.query.teamId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.memberList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // addMember() {},
    // 格式化时间
    formatter(row) {
      return formatDate(row.createTime, "YYYY-MM-DD HH:mm:ss");
    },
    // 删除
    deleteRow(teamUserId, nickName) {
      this.$confirm(`确定要将${nickName}从队伍中移除吗?`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          delTeamMember(teamUserId).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.getList();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    handleCaptain(teamUserId, nickName) {
      this.$confirm(`确定要将${nickName}任命为队长吗?`, {
        type: "warning",
      })
        .then(() => {
          this.$loading.show();
          upCaptain(teamUserId).then((res) => {
            this.$loading.hide();
            if (res.code == 0) {
              this.$message.success("队长更换成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.teamDetail {
  padding: 20px 33px;
  background-color: rgb(255, 255, 255);
  ::v-deep .el-page-header {
    .el-page-header__content {
      font-size: 14px;
    }
  }
  .search_form {
    text-align: left;

    .el-form-item {
      margin-right: 40px;

      &.btns {
        margin-left: 55px;
        margin-right: 0;
      }
    }
  }

  .add_btn {
    width: 100%;
  }

  ::v-deep .team_list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>